import { IAnalyticsController } from "./IAnalyticsController";

export class GoogleTagAnalyticsController implements IAnalyticsController
{
	constructor()
	{
		console.log("GoogleTagAnalyticsController");
	}

	async initialize(): Promise<boolean> {
		console.log("GoogleTagAnalyticsController::initialized");
		return true;
	}

	logEvent(eventName:string, eventParams?:{[key: string]: any}):void
	{
		console.log(`logEvent(${eventName})`, eventParams?JSON.stringify(eventParams):'No params');
		const dataLayer = (<any>window).dataLayer;
		if(dataLayer)
		{
			const event = {
				'event': eventName
			};
			if(eventParams)
			{
				Object.assign(event, eventParams); // copy over properties
			}
			dataLayer.push(event);
		}
		else
		{
			console.warn("GoogleTagAnalyticsController::No dataLayer available!");
		}
	}
}